import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixSelect from "@radix-ui/react-select";
import { forwardRef } from "react";
export const selectItem = tailwindVariants({
    base: "group/select-item flex shrink-0 cursor-pointer items-center rounded px-1.5 text-inherit outline-none radix-disabled:cursor-not-allowed radix-disabled:bg-transparent radix-disabled:opacity-50 radix-highlighted:bg-grey-4 hover:bg-grey-4 disabled:cursor-not-allowed",
    variants: {
        size: {
            small: "min-h-[32px] text-14",
            large: "min-h-[36px] text-16"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const SelectItem = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, prefix, size, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(RadixSelect.Item, {
        className: selectItem({
            size,
            class: className
        }),
        "data-testid": "SELECT_ITEM",
        ...restOfProps,
        ref: forwardedRef,
        children: [
            !!prefix ? /*#__PURE__*/ _jsx("div", {
                className: "flex shrink-0 items-center justify-center",
                children: prefix
            }) : null,
            /*#__PURE__*/ _jsx("span", {
                className: "grow",
                children: /*#__PURE__*/ _jsx(RadixSelect.ItemText, {
                    children: children
                })
            }),
            /*#__PURE__*/ _jsx(RadixSelect.ItemIndicator, {
                className: "shrink-0",
                children: /*#__PURE__*/ _jsx(Check, {
                    className: "size-4 text-blue-9"
                })
            })
        ]
    });
});
SelectItem.displayName = "SelectItem";
